export default __webpack_public_path__ + "76297e062e807f6cddda971326744327.png";